export const ORIENTATION = {
  VERTICAL: 1,
  LANDSCAPE: 2,
  UNKNOWN: 3,
};
